import { dynamicUrl } from '@mc/mc-ecs-storage/configuration/trackingSetup';
import { dispatchDynamicEventById } from '@mc/mc-ecs-storage/configuration/dispatchDynamicEvent';

/**
 * DEFAULT_PROPERTIES must use properties required by Authoring Tool to retrieve the tracking plan
 */
const DEFAULT_PROPERTIES = {
  event_sender_asset_alias: 'Intuit.crmmktg.mktchnlmgmt.mcsurvey',
  event_sender_asset_id: '4330228635041743020',
  event_sender_asset_name: 'mc-survey',
  event_sender_asset_version: 'latest',
  event_sender_name: 'mc-survey/mcapp',
  event_sender_version: 'latest',
};

/**
 * Creates the dynamic tracking URL between testing and production environments
 */
const DYNAMIC_CONFIG: string = dynamicUrl(DEFAULT_PROPERTIES);

/**
 * DON'T USE THIS DIRECTLY -- use track from web/js/src/Survey/shared/helpers/utils.ts,
 * which calls this, instead.
 * Create the dynamic tracking event and send to mc-ecs-event-emitter library
 * This library will validate, use Authoring Tool data, and send to Segment.
 *
 * @param dynamicId Dynamic ID must match Authoring Tool
 * @param additionalProperties Any optional additional properties to send with the event
 */
export const createTrackingEvent = (
  dynamicId: string,
  additionalProperties: {
    survey_id?: number;
    [key: string]: string | number | undefined;
  } = {},
) =>
  dispatchDynamicEventById(
    DYNAMIC_CONFIG,
    dynamicId,
    DEFAULT_PROPERTIES,
    additionalProperties,
  );

// Your DynamicIDs goes here 👇
// comment to describe the dynamic ID, this will get populated into the AuthoringTool as an event description

/////////////////////
// Survey overview //
/////////////////////
// Hero create CTA
export const SURVEYS_OVERVIEW_HERO_CREATE_SURVEY_BUTTON_CLICKED =
  'surveys_overview_hero_create_survey_button_clicked';

///////////////////
// Survey editor //
///////////////////
// User adds an image to their survey in the Design step
export const SURVEYS_DESIGN_ADD_IMAGE_BUTTON_CLICKED =
  'surveys_design_add_image_button_clicked';
